import { render, staticRenderFns } from "./apiRateLimit__list.vue?vue&type=template&id=03631c68"
import script from "./apiRateLimit__list.vue?vue&type=script&lang=js"
export * from "./apiRateLimit__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports